module.exports = __webpack_public_path__ + "static/media/drowsiness.23c99f7d.svg";